import { RouteRecordRaw } from 'vue-router'
import Layout from '@/layout/Index.vue'

const NotificationRouter: Array<RouteRecordRaw> = [
  {
    path: '/notification',
    component: Layout,
    children: [
      {
        path: '',
        name: 'Notification',
        component: () => import('@/views/notification/Index.vue'),
        meta: {
          title: '我的消息',
          icon: 'message',
          hidden: true
        }
      }
    ]
  }
]

export default NotificationRouter
